import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const RateInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Rate Information">
            <DataRow label="Buy Rate"  value={pdfData.buy_rate}/>
            <DataRow label="Rate Markup" value={pdfData.rate_markup} variant="muted"/>
            <DataRow
                label="Disclosed Rate"
                value={pdfData.disclosed_rate}
                isTotal
                variant="bold"
                isLast
            />
        </Panel>
    )
}
